import { type datadogRum as DatadogRum } from '@datadog/browser-rum'
import React from 'react'

import { getConfig } from 'EnvConfig'

let datadogRum: undefined | typeof DatadogRum
const importDatadog = async () => {
  if (datadogRum) return datadogRum

  return (datadogRum = (await import('@datadog/browser-rum')).datadogRum)
}

const useDatadog = () => datadogRum

export const useDatadogInitialization = (shouldInit: boolean) => {
  const [initialized, setInitialized] = React.useState(false)

  React.useEffect(() => {
    if (!shouldInit || initialized || getConfig().STAGE !== 'prod') {
      return
    }

    ;(async () => {
      const datadogRum = await importDatadog()

      /**
       * DataDog Config
       */
      datadogRum.init({
        applicationId: '01a74178-cb3c-4a5c-bbfb-5c855ee4214c',
        clientToken: getConfig().DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'customer-portal',
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
      })

      datadogRum.onReady(() => {
        /**
         * custom browser analytics
         */
        let width = window.innerWidth || document.body.clientWidth
        let height = window.innerHeight || document.body.clientHeight

        width = Math.round(width / 100) * 100
        height = Math.round(height / 100) * 100

        const size = width + 'x' + height

        datadogRum.setGlobalContextProperty('browser-analytics', {
          browser_size: size
        })
      })

      setInitialized(true)
    })()
  }, [initialized, shouldInit])
}

export default useDatadog
